export const config = {
    apiKey: "AIzaSyBsaWJkCqX5WlcfVeqrwPHmCU9wbLtWuv8",
    authDomain: "recenteurs.firebaseapp.com",
    databaseURL: "https://recenteurs.firebaseio.com",
    projectId: "recenteurs",
    storageBucket: "recenteurs.appspot.com",
    messagingSenderId: "397598667679"
  };